import { styled } from "goober";

export const InstructionsStep = styled("div")`
  display: flex;
  flex-direction: column;
  background: var(--surface-secondary);
  gap: 12px;
  padding: 24px;
  border-radius: 12px;
  border: 0.5px solid var(--border-alpha);
`;

export const StepHeading = styled("h3")`
  font-weight: 600;
  margin-bottom: 12px;
`;
